import { render, staticRenderFns } from "./settlementDoc.vue?vue&type=template&id=3da7584c&scoped=true"
import script from "./settlementDoc.vue?vue&type=script&lang=js"
export * from "./settlementDoc.vue?vue&type=script&lang=js"
import style0 from "./settlementDoc.vue?vue&type=style&index=0&id=3da7584c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7584c",
  null
  
)

export default component.exports